<template>
	<svg :style="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 467 308" fill="none">
		<path d="M158.766 308H0L308.234 0H467L158.766 308Z" :class="color"/>
	</svg>
</template>

<script>
const mediaQueryMobile = window.matchMedia(`(max-width: 768px)`)

export default {
	name: 'slash',
	props: {
		color: {
			type: String,
			default: '',
		},
		height: {
			type: [Number, String],
			default: 50,
		},
		width: {
			type: [Number, String],
			default: null,
		},
		mobileHeight: {
			type: Number,
			default: null,
		},
		xoffset: {
			type: String,
			default: null,
		},
		yoffset: {
			type: String,
			default: null,
		},
		index: {
			type: Number,
			default: 1,
		},
		reverse: {
			type: Boolean,
			default: false,
		},
		inverse: {
			type: Boolean,
			default: false,
		},
		absolute: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		theHeight() {
			if (mediaQueryMobile.matches && this.mobileHeight) {
				return this.mobileHeight
			}
			return this.height
		},
		theWidth() {
			if (this.width) return this.width
			if (mediaQueryMobile.matches && this.mobileHeight) {
				return Math.round(Number(this.mobileHeight) / 0.79957356)
			}
			return Math.round(Number(this.height) / 0.79957356)
		},
		classObject() {
			let _class = {}
			_class[this.color] = true
			_class['inverse'] = this.inverse

			return _class
		},
		style() {
			let style = this.xoffset || this.yoffset ? `transform: ` : ``
			style = ``
			if (this.xoffset) {
				style += `left: ${this.xoffset}; `
			}
			if ((this.yoffset)){
				style += `top: ${this.yoffset}; `
			}
			if (this.index) {
				style += `; z-index: ${this.index}`
			}
			if (this.absolute) {
				style += `; position: absolute `
			}

			return style
		},
	},
}
</script>


<style scoped lang="scss">
svg {
	path {
		fill: var(--color, var(--color--gold));
		transition: fill linear 150ms;
	}
	pointer-events: none;

	@include modules.media-query('phone') {
		display: none;
	}
}

.gold {
	fill: var(--color--gold);

	&.inverse {
		fill: var(--color--background);
	}
}

.yellow {
	fill: var(--color--yellow);

	&.inverse {
		fill: var(--color--background);
	}
}

.mint {
	fill: var(--color--mint);

	&.inverse {
		fill: var(--color--background);
	}
}

.orange {
	fill: var(--color--orange);

	&.inverse {
		fill: var(--color--background);
	}
}

.hunter {
	fill: var(--color--hunter-green);

	&.inverse {
		fill: var(--color--background);
	}
}

.green {
	fill: var(--color--dark-green);

	&.inverse {
		fill: var(--color--background);
	}
}

.cream {
	fill: var(--color--cream);

	&.inverse {
		fill: var(--color--background);
	}
}

.white {
	fill: var(--color--background);
}

.reverse {
	transform: rotate(180deg);
	transform-origin: center center;
}

</style>
